module.exports = __webpack_public_path__ + "2ab81ad299bd0186d34720743a23688b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/vokabular.svg
// module id = 11
// module chunks = 0